const PROPERTY_PATH_SEGMENT = /\[([^\]]+)\]/g

export const parseSymfonyPropertyPath = path => {
    if (typeof path !== 'string' || !path) {
        return []
    }

    const segments = []
    let match = PROPERTY_PATH_SEGMENT.exec(path)
    while (match) {
        segments.push(match[1])
        match = PROPERTY_PATH_SEGMENT.exec(path)
    }
    PROPERTY_PATH_SEGMENT.lastIndex = 0

    return segments
}

export const valueAtSymfonyPropertyPath = (value, path) => {
    const segments = parseSymfonyPropertyPath(path)
    if (!segments.length) {
        return undefined
    }

    return segments.reduce((current, segment) => (
        current === null || typeof current === 'undefined'
            ? undefined
            : current[segment]
    ), value)
}

export const substanceViolationTarget = violation => {
    const segments = parseSymfonyPropertyPath(violation && violation.path)
    if (segments[0] !== 'substanceAssessment'
        || segments[1] !== 'substances'
        || !/^\d+$/.test(segments[2] || '')
        || !segments[3]) {
        return null
    }

    return {
        index: Number(segments[2]),
        field: segments[3],
    }
}
